import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Schedule} from '../models/Schedule';

@Injectable()
export class ScheduleService {

  constructor(private httpClient: HttpClient) {
  }

  getSchedules(): Observable<Schedule[]> {
    return this.httpClient.get<Schedule[]>(environment.baseUrlWs + '/api/schedules');
  }

}
